export const ADD_PHONEBOOK_CONTACTS = 'ADD_PHONEBOOK_CONTACTS'
export const CLEAR_PHONEBOOK_CONTACTS = 'CLEAR_PHONEBOOK_CONTACTS'
export const MARK_CONTACT_AS_CHECKED = 'MARK_CONTACT_AS_CHECKED'
export const MARK_CONTACT_AS_UNCHECKED = 'MARK_CONTACT_AS_UNCHECKED'
